import moment from 'moment';

export const getGiveawaySessionHistoryResponse = (response) => {
  const giveaway = response?.giveaway;

  return {
    productName: giveaway?.productName,
    totalStock: giveaway?.totalStock,
    brand: giveaway?.brand?.name,
    imagePath: giveaway?.imagePath ?? [],
    sessionHistories:
      giveaway?.sessionHistories?.map((session) => {
        const promoDate = moment(session?.giveawayDuration?.promotionDate, 'YYYY-MM-DD').format('DD MMM YY');
        return {
          images: session?.images?.map((img) => img?.imagePath) ?? [],
          createdAt: session?.createdAt,
          usedStock: session?.usedStock,
          note: session?.note,
          host: session?.host?.name,
          giveawayDuration: {
            startDate: `${promoDate} | ${moment(session?.giveawayDuration?.startTime, 'HH:mm:ss').format('HH:mm')}`,
            endDate: `${promoDate} | ${moment(session?.giveawayDuration?.endTime, 'HH:mm:ss').format('HH:mm')}`,
          },
          account: session?.accountLivestream
            ? {
                accountName: session?.accountLivestream?.name,
                ecommerce: session?.accountLivestream?.ecommerce,
              }
            : null,
        };
      }) ?? [],
  };
};

export default getGiveawaySessionHistoryResponse;
